<template>
  <div class="cui-users__main-container">
    <v-list-item three-line v-if="getUserData">
        <v-list-item-avatar
            round
            size="48"
            color="#00667c"
            class="mr-8 my-auto">
            <span style="font-size: 1.3em; color:#fff">{{getUserData.user.name.given | firstChar}}{{getUserData.user.name.surname | firstChar}}</span></v-list-item-avatar>
        <v-list-item-content>
            <div class="font-weight-bold" style="font-size: 1.125em; letter-spacing: 1.6px">
            {{getUserData.user.name.given}} {{getUserData.user.name.surname}}
            </div>
            <v-list-item-subtitle grey class="font-weight-medium">Registered: {{getUserData.user.activatedDate | formatDate(getUserData.user.timezone)}}</v-list-item-subtitle>
            <v-list-item-subtitle grey class="font-weight-medium">User ID: {{getUserData.user.username}}</v-list-item-subtitle>
            <v-list-item-subtitle grey class="font-weight-medium">Last Login: {{getUserData.user.lastLoginDate | formatDate(getUserData.user.timezone)}}</v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
    <ProfileTabs />
</div>
</template>
<script>
/* eslint-disable */
// eslint-disable-next-line

import ProfileTabs from '@/components/partials/ProfileTabs'
export default {
computed: {
    getUserData () {
      return this.$store.getters.getUserInfo
    }
  },
  components: {
    ProfileTabs
  },
  data () {
    return {
      userInfo: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Profile.vue